export const SITE_URL = "https://seobix.com";

export const DEFAULT_OG_IMAGE = `${SITE_URL}/Images/Backlinks.png`;

export const seoPages = {
  "/": {
    path: "/",
    title: "SeoBix - Free Domain Authority Checker &amp; SEO Tools",
    description:
      "Check Domain Authority, website ranking & SEO health instantly with SeoBix's free tools for keyword research, audits & backlink tracking.",
    keywords:
      "SEO tools, website audit tool, keyword research tool, backlink checker, rank tracker, SEO content tools",
    breadcrumbName: "Home",
    schemaType: "home",
  },
  "/da-pa-checker": {
    path: "/da-pa-checker",
    title: "DA PA Checker - Check Domain Authority and Page Authority",
    description:
      "Use SeoBix DA PA Checker to check domain authority, page authority, spam score, and website SEO strength in one simple tool.",
    keywords:
      "DA PA checker, domain authority checker, page authority checker, website authority checker, SEO authority tool",
    breadcrumbName: "DA PA Checker",
    schemaType: "tool",
    softwareKeywords:
      "DA Checker, PA Checker, Domain Authority Checker, Page Authority Checker, SEO Tool",
    featureList: [
      "Check Domain Authority",
      "Check Page Authority",
      "Analyze Spam Score",
      "Bulk URL Analysis",
      "SEO Strength Checker",
    ],
  },
  "/serp-simulator": {
    path: "/serp-simulator",
    title: "SERP Simulator - Preview Google Title and Meta Description",
    description:
      "Preview how your page title, URL, and meta description may appear in Google search results with the SeoBix SERP Simulator.",
    keywords:
      "SERP simulator, Google snippet preview, meta title preview, meta description preview, SEO snippet tool",
    breadcrumbName: "SERP Simulator",
    schemaType: "tool",
    softwareKeywords:
      "SERP Simulator, Google Snippet Preview, Meta Title Preview, Meta Description Preview, SEO Tool",
    featureList: [
      "Preview Google Search Snippets",
      "Test Meta Titles",
      "Test Meta Descriptions",
      "Optimize Search CTR",
      "Review URL Display",
    ],
  },
  "/keyword-gap": {
    path: "/keyword-gap",
    title: "Keyword Gap Tool - Find Competitor Keywords You Are Missing",
    description:
      "Use SeoBix Keyword Gap Tool to compare keyword opportunities, discover competitor rankings, and improve your SEO content strategy.",
    keywords:
      "keyword gap tool, competitor keyword analysis, SEO keyword gap, missing keywords, keyword research",
    breadcrumbName: "Keyword Gap",
    schemaType: "tool",
    softwareKeywords:
      "Keyword Gap Tool, Competitor Keyword Analysis, Missing Keywords, SEO Keyword Gap, SEO Tool",
    featureList: [
      "Find Competitor Keywords",
      "Discover Missing Keywords",
      "Compare Keyword Opportunities",
      "Identify SEO Content Gaps",
      "Improve Organic Search Strategy",
    ],
  },
  "/top-pages": {
    path: "/top-pages",
    title: "Top Pages Tool - Find Best Performing Pages of Any Website",
    description:
      "Use SeoBix Top Pages Tool to discover popular, high-traffic, and high-value pages for competitor analysis and SEO strategy improvement.",
    keywords:
      "top pages tool, best performing pages, competitor page analysis, website traffic pages, top ranking pages",
    breadcrumbName: "Top Pages",
    schemaType: "tool",
    softwareKeywords:
      "Top Pages Tool, Best Performing Pages, Competitor Page Analysis, Website Traffic Pages, SEO Tool",
    featureList: [
      "Find Top Performing Pages",
      "Analyze Competitor Pages",
      "Discover High-Value URLs",
      "Review SEO Page Performance",
      "Improve Content Strategy",
    ],
  },
  "/seo-Inspector": {
    path: "/seo-Inspector",
    title: "SEO Inspector - Analyze Website SEO and Fix Issues",
    description:
      "Run a website SEO inspection with SeoBix to check meta tags, headings, on-page SEO, technical issues, and optimization opportunities.",
    keywords:
      "SEO inspector, website SEO audit, SEO analysis tool, on-page SEO checker, technical SEO audit",
    breadcrumbName: "SEO Inspector",
    schemaType: "tool",
    softwareKeywords:
      "SEO Inspector, Website SEO Audit, Technical SEO Audit, On-Page SEO Checker, SEO Tool",
    featureList: [
      "Audit Website SEO",
      "Check Meta Tags",
      "Analyze Heading Structure",
      "Find Technical SEO Issues",
      "Review Optimization Opportunities",
    ],
  },
  "/on-page-seo-tool": {
    path: "/on-page-seo-tool",
    title: "On-Page SEO Tool - Analyze and Optimize Web Pages",
    description:
      "Use SeoBix On-Page SEO Tool to review titles, descriptions, headings, keywords, content signals, and page-level SEO improvements.",
    keywords:
      "on-page SEO tool, SEO page checker, meta tag checker, heading checker, content optimization tool",
    breadcrumbName: "On-Page SEO Tool",
    schemaType: "tool",
    softwareKeywords:
      "On-Page SEO Tool, Meta Tag Checker, Heading Checker, Content Optimization, SEO Tool",
    featureList: [
      "Analyze On-Page SEO",
      "Check Page Titles",
      "Review Meta Descriptions",
      "Analyze Keyword Usage",
      "Optimize Page Content",
    ],
  },
  "/structured-data": {
    path: "/structured-data",
    title: "Structured Data Tool - Generate Schema Markup for SEO",
    description:
      "Create and validate structured data with SeoBix to help search engines understand your pages and support rich result eligibility.",
    keywords:
      "structured data tool, schema markup generator, JSON-LD generator, rich results SEO, schema tool",
    breadcrumbName: "Structured Data",
    schemaType: "tool",
    softwareKeywords:
      "Structured Data Tool, Schema Markup Generator, JSON-LD Generator, Rich Results, SEO Tool",
    featureList: [
      "Generate Schema Markup",
      "Create JSON-LD",
      "Support Rich Result Eligibility",
      "Improve Search Engine Understanding",
      "Build SEO Structured Data",
    ],
  },
  "/bix-content-generator": {
    path: "/bix-content-generator",
    title: "Bix Content Generator - AI Content Writing Tool for SEO",
    description:
      "Generate SEO-friendly content ideas, outlines, and drafts with Bix Content Generator by SeoBix for faster content workflows.",
    keywords:
      "AI content generator, SEO content generator, content writing tool, blog content generator, Bix content",
    breadcrumbName: "Bix Content Generator",
    schemaType: "tool",
    softwareKeywords:
      "AI Content Generator, SEO Content Generator, Blog Content Generator, Content Writing Tool, SEO Tool",
    featureList: [
      "Generate SEO Content Ideas",
      "Create Content Outlines",
      "Write Draft Content",
      "Improve Content Workflow",
      "Support Keyword-Focused Writing",
    ],
  },
  "/content-quality-checker": {
    path: "/content-quality-checker",
    title: "Content Quality Checker - Improve SEO Content Performance",
    description:
      "Analyze content quality, readability, keyword usage, and optimization signals with SeoBix Content Quality Checker.",
    keywords:
      "content quality checker, SEO content checker, readability checker, content optimization, quality content tool",
    breadcrumbName: "Content Quality Checker",
    schemaType: "tool",
    softwareKeywords:
      "Content Quality Checker, SEO Content Checker, Readability Checker, Content Optimization, SEO Tool",
    featureList: [
      "Check Content Quality",
      "Analyze Readability",
      "Review Keyword Usage",
      "Find Content Gaps",
      "Improve SEO Content Performance",
    ],
  },
  "/bix-humanizer": {
    path: "/bix-humanizer",
    title: "Bix Humanizer - Make AI Content More Natural",
    description:
      "Use Bix Humanizer by SeoBix to improve AI-generated text, make content easier to read, and support natural SEO writing.",
    keywords:
      "AI humanizer, Bix humanizer, humanize AI text, natural content tool, AI writing improvement",
    breadcrumbName: "Bix Humanizer",
    schemaType: "tool",
    softwareKeywords:
      "AI Humanizer, Humanize AI Text, Natural Content Tool, AI Writing Improvement, SEO Tool",
    featureList: [
      "Humanize AI Text",
      "Improve Content Readability",
      "Make Writing More Natural",
      "Refine AI-Generated Drafts",
      "Support SEO-Friendly Writing",
    ],
  },
  "/backlink-checker": {
    path: "/backlink-checker",
    title: "Backlink Checker - Analyze Website Backlinks",
    description:
      "Check website backlinks, referring domains, and link signals with SeoBix Backlink Checker to strengthen your SEO strategy.",
    keywords:
      "backlink checker, website backlink analysis, referring domains, SEO backlink tool, link analysis",
    breadcrumbName: "Backlink Checker",
    schemaType: "tool",
    softwareKeywords:
      "Backlink Checker, Website Backlink Analysis, Referring Domains, Link Analysis, SEO Tool",
    featureList: [
      "Check Website Backlinks",
      "Analyze Referring Domains",
      "Review Link Profile Strength",
      "Find Backlink Opportunities",
      "Monitor Off-Page SEO Signals",
    ],
  },
  "/link-building-tool": {
    path: "/link-building-tool",
    title: "Link Building Tool - Find SEO Backlink Opportunities",
    description:
      "Discover link building opportunities, track outreach ideas, and improve off-page SEO planning with SeoBix Link Building Tool.",
    keywords:
      "link building tool, backlink opportunities, SEO outreach tool, off-page SEO, link prospecting",
    breadcrumbName: "Link Building Tool",
    schemaType: "tool",
    softwareKeywords:
      "Link Building Tool, Backlink Opportunities, SEO Outreach, Off-Page SEO, SEO Tool",
    featureList: [
      "Find Link Building Opportunities",
      "Plan SEO Outreach",
      "Discover Backlink Prospects",
      "Improve Off-Page SEO",
      "Track Link Opportunity Ideas",
    ],
  },
  "/linking-domain-checker": {
    path: "/linking-domain-checker",
    title: "Linking Domain Checker - Analyze Referring Domains",
    description:
      "Use SeoBix Linking Domain Checker to review referring domains, backlink sources, and link profile strength for any website.",
    keywords:
      "linking domain checker, referring domains checker, backlink domains, SEO link profile, domain links",
    breadcrumbName: "Linking Domain Checker",
    schemaType: "tool",
    softwareKeywords:
      "Linking Domain Checker, Referring Domains Checker, Backlink Domains, Link Profile Analysis, SEO Tool",
    featureList: [
      "Check Linking Domains",
      "Analyze Referring Domains",
      "Review Backlink Sources",
      "Measure Link Profile Strength",
      "Find Domain-Level Link Signals",
    ],
  },
  "/best-keyword-research-tool": {
    path: "/best-keyword-research-tool",
    title: "Keyword Research Tool - Find SEO Keywords with SeoBix",
    description:
      "Find keyword ideas, search intent, ranking opportunities, and SEO content topics with the SeoBix Keyword Research Tool.",
    keywords:
      "keyword research tool, SEO keyword finder, keyword ideas, keyword analysis, search intent tool",
    breadcrumbName: "Keyword Research Tool",
    schemaType: "tool",
    softwareKeywords:
      "Keyword Research Tool, SEO Keyword Finder, Keyword Ideas, Search Intent Tool, SEO Tool",
    featureList: [
      "Find Keyword Ideas",
      "Analyze Search Intent",
      "Discover SEO Topics",
      "Review Ranking Opportunities",
      "Plan Keyword-Focused Content",
    ],
  },
  "/bix-keyword-analyzer": {
    path: "/bix-keyword-analyzer",
    title: "Bix Keyword Analyzer - Analyze SEO Keyword Performance",
    description:
      "Analyze SEO keywords, ranking potential, competition signals, and content opportunities with Bix Keyword Analyzer by SeoBix.",
    keywords:
      "keyword analyzer, SEO keyword analysis, keyword performance tool, keyword ranking checker, Bix keyword",
    breadcrumbName: "Bix Keyword Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "Keyword Analyzer, SEO Keyword Analysis, Keyword Performance Tool, Keyword Ranking Checker, SEO Tool",
    featureList: [
      "Analyze Keyword Performance",
      "Review Ranking Potential",
      "Check Competition Signals",
      "Find Content Opportunities",
      "Improve Keyword Strategy",
    ],
  },
  "/search-console": {
    path: "/search-console",
    title: "Search Console Tool - Monitor Website SEO Performance",
    description:
      "Use SeoBix Search Console tools to review website performance, keyword visibility, indexing insights, and SEO opportunities.",
    keywords:
      "search console tool, SEO performance monitor, keyword visibility, website indexing, Google Search Console",
    breadcrumbName: "Search Console",
    schemaType: "tool",
    softwareKeywords:
      "Search Console Tool, SEO Performance Monitor, Keyword Visibility, Website Indexing, SEO Tool",
    featureList: [
      "Monitor SEO Performance",
      "Review Keyword Visibility",
      "Analyze Indexing Insights",
      "Find Search Opportunities",
      "Track Website Search Signals",
    ],
  },
  "/trending-now-on-google": {
    path: "/trending-now-on-google",
    title: "Trending Now on Google - Discover Search Trends",
    description:
      "Find trending searches, popular topics, and fresh keyword ideas with SeoBix Trending Now on Google tool.",
    keywords:
      "Google trends, trending searches, trending keywords, search trends tool, viral topics",
    breadcrumbName: "Trending Now on Google",
    schemaType: "tool",
    softwareKeywords:
      "Google Trends Tool, Trending Searches, Trending Keywords, Search Trends, SEO Tool",
    featureList: [
      "Find Trending Searches",
      "Discover Popular Topics",
      "Research Fresh Keyword Ideas",
      "Track Search Interest",
      "Support Trend-Based Content Planning",
    ],
  },
  "/partners": {
    path: "/partners",
    title: "SeoBix Partners - Grow With Our SEO Partner Network",
    description:
      "Explore SeoBix partner opportunities and collaboration options for agencies, businesses, and digital growth teams.",
    keywords:
      "SeoBix partners, SEO partner program, digital marketing partners, agency partnership, SEO collaboration",
    breadcrumbName: "Partners",
    schemaType: "webpage",
  },
  "/blog": {
    path: "/blog",
    title: "SeoBix Blog - SEO, Digital Marketing and Website Growth",
    description:
      "Read SeoBix blog articles about SEO tools, keyword research, backlinks, technical SEO, content optimization, and digital growth.",
    keywords:
      "SeoBix blog, SEO blog, digital marketing blog, keyword research blog, backlink blog",
    breadcrumbName: "Blog",
    schemaType: "blog",
  },
  "/pricing-plans": {
    path: "/pricing-plans",
    title: "SeoBix Pricing Plans - SEO Tool Packages and Free Trial",
    description:
      "Compare SeoBix pricing plans and choose SEO tools for audits, keyword tracking, backlinks, content, and website growth.",
    keywords:
      "SeoBix pricing, SEO tool pricing, SEO software plans, SEO package, free SEO trial",
    breadcrumbName: "Pricing Plans",
    schemaType: "pricing",
  },
  "/faq": {
    path: "/faq",
    title: "SeoBix FAQ - SEO Tools, Pricing and Support Questions",
    description:
      "Find answers to common questions about SeoBix SEO tools, pricing plans, website audits, keyword tools, and support.",
    keywords:
      "SeoBix FAQ, SEO tools questions, SeoBix support, SEO pricing FAQ, website audit FAQ",
    breadcrumbName: "FAQ",
    schemaType: "faq",
  },
  "/privacy-policy": {
    path: "/privacy-policy",
    title: "Privacy Policy - How SeoBix Protects Your Data",
    description:
      "Read the SeoBix Privacy Policy to understand how we collect, use, protect, and manage your information.",
    keywords:
      "SeoBix privacy policy, data protection, user privacy, website privacy policy",
    breadcrumbName: "Privacy Policy",
    schemaType: "policy",
  },
  "/terms-and-conditions": {
    path: "/terms-and-conditions",
    title: "Terms and Conditions - SeoBix Website and SEO Tools",
    description:
      "Read the SeoBix Terms and Conditions for using our website, SEO tools, services, subscriptions, and content.",
    keywords:
      "SeoBix terms and conditions, SEO tool terms, website terms, service terms",
    breadcrumbName: "Terms and Conditions",
    schemaType: "policy",
  },
};

Object.assign(seoPages, {
  "/guest-post": {
    path: "/guest-post",
    title: "Write for Us - Submit Guest Post on SeoBix",
    description:
      "Submit a guest post to SeoBix and share SEO, digital marketing, content, and website growth insights with our audience.",
    keywords:
      "write for us, guest post, SEO guest post, digital marketing guest post, submit guest post",
    breadcrumbName: "Guest Post",
    schemaType: "webpage",
  },
  "/google-analytics": {
    path: "/google-analytics",
    title: "Google Analytics Tool - Analyze Website Traffic and Insights",
    description:
      "Use SeoBix Google Analytics tools to understand website traffic, user behavior, performance trends, and growth opportunities.",
    keywords:
      "Google Analytics tool, website traffic analysis, analytics insights, traffic tracking, SEO analytics",
    breadcrumbName: "Google Analytics",
    schemaType: "tool",
    softwareKeywords:
      "Google Analytics Tool, Website Traffic Analysis, Analytics Insights, SEO Analytics, SEO Tool",
    featureList: [
      "Analyze Website Traffic",
      "Review User Behavior",
      "Track Performance Trends",
      "Find Growth Opportunities",
      "Monitor SEO Analytics",
    ],
  },
  "/manage-robots-txt": {
    path: "/manage-robots-txt",
    title: "Robots.txt Generator and Tester - Manage Robots.txt Easily",
    description:
      "Create, edit, and test robots.txt rules with SeoBix to control crawler access and improve website indexing.",
    keywords:
      "robots.txt generator, robots.txt tester, manage robots txt, crawler access, SEO robots file",
    breadcrumbName: "Robots.txt Manager",
    schemaType: "tool",
    softwareKeywords:
      "Robots.txt Generator, Robots.txt Tester, Manage Robots.txt, Crawler Access, SEO Tool",
    featureList: [
      "Generate Robots.txt",
      "Test Robots Rules",
      "Manage Crawler Access",
      "Protect Private Pages",
      "Improve Crawl Control",
    ],
  },
  "/construct-your-seo-success-with-keyword-builder": {
    path: "/construct-your-seo-success-with-keyword-builder",
    title: "Keyword Builder Tool - Build SEO Keyword Strategies",
    description:
      "Use SeoBix Keyword Builder to create keyword groups, plan SEO topics, and build stronger organic search strategies.",
    keywords:
      "keyword builder, SEO keyword strategy, keyword grouping, keyword planning, SEO tool",
    breadcrumbName: "Keyword Builder",
    schemaType: "tool",
    softwareKeywords:
      "Keyword Builder, SEO Keyword Strategy, Keyword Grouping, Keyword Planning, SEO Tool",
    featureList: [
      "Build Keyword Groups",
      "Plan SEO Topics",
      "Create Keyword Strategies",
      "Find Related Keywords",
      "Organize Search Opportunities",
    ],
  },
  "/youtube-scheduled-publishing": {
    path: "/youtube-scheduled-publishing",
    title: "YouTube Scheduled Publishing Tool - Plan Video Publishing",
    description:
      "Plan and schedule YouTube publishing workflows with SeoBix tools for consistent video content management.",
    keywords:
      "YouTube scheduled publishing, YouTube scheduler, video publishing tool, YouTube content planning",
    breadcrumbName: "YouTube Scheduled Publishing",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Scheduled Publishing, YouTube Scheduler, Video Publishing Tool, Social Media Tool",
    featureList: [
      "Plan YouTube Publishing",
      "Schedule Video Content",
      "Manage Publishing Workflows",
      "Improve Posting Consistency",
      "Organize Video Campaigns",
    ],
  },
  "/youtube-subscription-tracker": {
    path: "/youtube-subscription-tracker",
    title: "YouTube Subscription Tracker - Track Channel Subscribers",
    description:
      "Track YouTube subscriber growth and channel subscription signals with SeoBix YouTube tools.",
    keywords:
      "YouTube subscription tracker, subscriber tracker, YouTube growth tool, channel analytics",
    breadcrumbName: "YouTube Subscription Tracker",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Subscription Tracker, Subscriber Tracker, YouTube Growth Tool, Social Media Tool",
    featureList: [
      "Track Subscriber Growth",
      "Monitor Channel Progress",
      "Review Subscription Signals",
      "Analyze Audience Growth",
      "Support YouTube Strategy",
    ],
  },
  "/youtube-trending-tags-finder": {
    path: "/youtube-trending-tags-finder",
    title: "YouTube Trending Tags Finder - Discover Video Tags",
    description:
      "Find trending YouTube tags and video keyword ideas with SeoBix to improve discoverability and content planning.",
    keywords:
      "YouTube tags finder, trending YouTube tags, video tags, YouTube SEO, video keyword tool",
    breadcrumbName: "YouTube Trending Tags Finder",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Tags Finder, Trending YouTube Tags, Video Tags, YouTube SEO Tool",
    featureList: [
      "Find Trending Tags",
      "Discover Video Keywords",
      "Improve Video SEO",
      "Plan YouTube Topics",
      "Support Video Discoverability",
    ],
  },
  "/youtube-bix-intelligence": {
    path: "/youtube-bix-intelligence",
    title: "YouTube Bix Intelligence - Analyze YouTube Growth Insights",
    description:
      "Use YouTube Bix Intelligence by SeoBix to analyze video performance signals and improve YouTube growth strategy.",
    keywords:
      "YouTube intelligence, YouTube analytics, video performance insights, YouTube SEO tool",
    breadcrumbName: "YouTube Bix Intelligence",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Intelligence, YouTube Analytics, Video Performance Insights, YouTube SEO Tool",
    featureList: [
      "Analyze YouTube Insights",
      "Review Video Signals",
      "Improve Channel Strategy",
      "Track Content Opportunities",
      "Support YouTube SEO",
    ],
  },
  "/youtube-content-planner": {
    path: "/youtube-content-planner",
    title: "YouTube Content Planner - Plan Video Content Strategy",
    description:
      "Plan YouTube content ideas, campaigns, and publishing workflows with SeoBix YouTube Content Planner.",
    keywords:
      "YouTube content planner, video content strategy, YouTube planning tool, video ideas",
    breadcrumbName: "YouTube Content Planner",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Content Planner, Video Content Strategy, YouTube Planning Tool, Social Media Tool",
    featureList: [
      "Plan Video Ideas",
      "Organize Content Strategy",
      "Build Publishing Workflows",
      "Manage YouTube Campaigns",
      "Support Channel Growth",
    ],
  },
  "/youtube-insight-analyzer": {
    path: "/youtube-insight-analyzer",
    title: "YouTube Insight Analyzer - Analyze Video and Channel Insights",
    description:
      "Analyze YouTube insights, content performance, and channel signals with SeoBix YouTube Insight Analyzer.",
    keywords:
      "YouTube insight analyzer, YouTube analytics tool, video insights, channel analysis",
    breadcrumbName: "YouTube Insight Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "YouTube Insight Analyzer, YouTube Analytics Tool, Video Insights, Social Media Tool",
    featureList: [
      "Analyze Video Insights",
      "Review Channel Signals",
      "Track Content Performance",
      "Find Growth Opportunities",
      "Improve YouTube Strategy",
    ],
  },
  "/facebook-profile-page-analyzer": {
    path: "/facebook-profile-page-analyzer",
    title: "Facebook Profile Page Analyzer - Review Page Performance",
    description:
      "Analyze Facebook profile and page signals with SeoBix to improve social media performance and visibility.",
    keywords:
      "Facebook profile analyzer, Facebook page analyzer, social media analysis, Facebook SEO",
    breadcrumbName: "Facebook Profile Page Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "Facebook Profile Analyzer, Facebook Page Analyzer, Social Media Analysis, SMO Tool",
    featureList: [
      "Analyze Facebook Profiles",
      "Review Page Signals",
      "Improve Social Visibility",
      "Track Profile Optimization",
      "Support SMO Strategy",
    ],
  },
  "/facebook-post-content-creator": {
    path: "/facebook-post-content-creator",
    title: "Facebook Post Content Creator - Create Social Post Ideas",
    description:
      "Create Facebook post ideas and social media content drafts with SeoBix for better engagement planning.",
    keywords:
      "Facebook post creator, Facebook content creator, social media post tool, content ideas",
    breadcrumbName: "Facebook Post Content Creator",
    schemaType: "tool",
    softwareKeywords:
      "Facebook Post Creator, Facebook Content Creator, Social Media Content Tool, SMO Tool",
    featureList: [
      "Create Facebook Post Ideas",
      "Draft Social Captions",
      "Plan Engagement Content",
      "Improve Social Posting",
      "Support Content Workflows",
    ],
  },
  "/facebook-post-scheduler": {
    path: "/facebook-post-scheduler",
    title: "Facebook Post Scheduler - Plan and Schedule Facebook Posts",
    description:
      "Plan and schedule Facebook posts with SeoBix tools to manage consistent social media publishing.",
    keywords:
      "Facebook post scheduler, Facebook scheduler, social media scheduling, post planning",
    breadcrumbName: "Facebook Post Scheduler",
    schemaType: "tool",
    softwareKeywords:
      "Facebook Post Scheduler, Social Media Scheduling, Post Planning, SMO Tool",
    featureList: [
      "Schedule Facebook Posts",
      "Plan Social Publishing",
      "Organize Content Calendar",
      "Improve Posting Consistency",
      "Manage Facebook Campaigns",
    ],
  },
  "/facebook-hashtag-finder": {
    path: "/facebook-hashtag-finder",
    title: "Facebook Hashtag Finder - Discover Social Hashtags",
    description:
      "Find Facebook hashtags and social topic ideas with SeoBix to improve post reach and engagement planning.",
    keywords:
      "Facebook hashtag finder, Facebook hashtags, social hashtags, hashtag research tool",
    breadcrumbName: "Facebook Hashtag Finder",
    schemaType: "tool",
    softwareKeywords:
      "Facebook Hashtag Finder, Facebook Hashtags, Hashtag Research, SMO Tool",
    featureList: [
      "Find Facebook Hashtags",
      "Research Social Topics",
      "Improve Post Reach",
      "Plan Hashtag Strategy",
      "Support Social Engagement",
    ],
  },
  "/linkedin-profile-analyzer": {
    path: "/linkedin-profile-analyzer",
    title: "LinkedIn Profile Analyzer - Optimize LinkedIn Presence",
    description:
      "Analyze LinkedIn profile signals with SeoBix to improve professional visibility and social media optimization.",
    keywords:
      "LinkedIn profile analyzer, LinkedIn optimization, profile analysis, professional branding",
    breadcrumbName: "LinkedIn Profile Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "LinkedIn Profile Analyzer, LinkedIn Optimization, Profile Analysis, SMO Tool",
    featureList: [
      "Analyze LinkedIn Profiles",
      "Review Profile Signals",
      "Improve Professional Visibility",
      "Optimize Personal Branding",
      "Support LinkedIn Growth",
    ],
  },
  "/linkedin-post-article-creator": {
    path: "/linkedin-post-article-creator",
    title: "LinkedIn Post and Article Creator - Generate LinkedIn Content",
    description:
      "Create LinkedIn post and article ideas with SeoBix for professional content planning and engagement.",
    keywords:
      "LinkedIn post creator, LinkedIn article creator, professional content, LinkedIn content tool",
    breadcrumbName: "LinkedIn Post Article Creator",
    schemaType: "tool",
    softwareKeywords:
      "LinkedIn Post Creator, LinkedIn Article Creator, Professional Content Tool, SMO Tool",
    featureList: [
      "Create LinkedIn Posts",
      "Generate Article Ideas",
      "Plan Professional Content",
      "Improve Engagement Strategy",
      "Support LinkedIn Publishing",
    ],
  },
  "/linkedin-post-scheduler": {
    path: "/linkedin-post-scheduler",
    title: "LinkedIn Post Scheduler - Schedule LinkedIn Content",
    description:
      "Plan and schedule LinkedIn posts with SeoBix to manage consistent professional social media publishing.",
    keywords:
      "LinkedIn post scheduler, LinkedIn scheduler, professional content scheduling, social media planning",
    breadcrumbName: "LinkedIn Post Scheduler",
    schemaType: "tool",
    softwareKeywords:
      "LinkedIn Post Scheduler, LinkedIn Scheduler, Social Media Planning, SMO Tool",
    featureList: [
      "Schedule LinkedIn Posts",
      "Plan Professional Content",
      "Manage Publishing Calendar",
      "Improve Posting Consistency",
      "Support LinkedIn Strategy",
    ],
  },
  "/linkedin-hashtag-research-tool": {
    path: "/linkedin-hashtag-research-tool",
    title: "LinkedIn Hashtag Research Tool - Find Professional Hashtags",
    description:
      "Research LinkedIn hashtags and topic ideas with SeoBix to improve content reach and professional visibility.",
    keywords:
      "LinkedIn hashtag research, LinkedIn hashtags, professional hashtags, hashtag tool",
    breadcrumbName: "LinkedIn Hashtag Research Tool",
    schemaType: "tool",
    softwareKeywords:
      "LinkedIn Hashtag Research, LinkedIn Hashtags, Professional Hashtags, SMO Tool",
    featureList: [
      "Research LinkedIn Hashtags",
      "Find Professional Topics",
      "Improve Content Reach",
      "Plan Hashtag Strategy",
      "Support LinkedIn Visibility",
    ],
  },
  "/instagram-profile-analyzer": {
    path: "/instagram-profile-analyzer",
    title: "Instagram Profile Analyzer - Analyze Instagram Performance",
    description:
      "Analyze Instagram profile signals with SeoBix to improve visibility, content strategy, and social engagement.",
    keywords:
      "Instagram profile analyzer, Instagram analytics, profile analysis, Instagram optimization",
    breadcrumbName: "Instagram Profile Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "Instagram Profile Analyzer, Instagram Analytics, Profile Analysis, SMO Tool",
    featureList: [
      "Analyze Instagram Profiles",
      "Review Profile Signals",
      "Improve Instagram Visibility",
      "Support Content Strategy",
      "Track Social Optimization",
    ],
  },
  "/instagram-post-reel-creator": {
    path: "/instagram-post-reel-creator",
    title: "Instagram Post and Reel Creator - Generate Social Content",
    description:
      "Create Instagram post and reel ideas with SeoBix for better social media content planning and engagement.",
    keywords:
      "Instagram post creator, Instagram reel creator, Instagram content ideas, social media content",
    breadcrumbName: "Instagram Post Reel Creator",
    schemaType: "tool",
    softwareKeywords:
      "Instagram Post Creator, Instagram Reel Creator, Social Content Tool, SMO Tool",
    featureList: [
      "Create Instagram Post Ideas",
      "Generate Reel Concepts",
      "Plan Social Content",
      "Improve Engagement Ideas",
      "Support Instagram Publishing",
    ],
  },
  "/instagram-post-scheduler": {
    path: "/instagram-post-scheduler",
    title: "Instagram Post Scheduler - Plan Instagram Publishing",
    description:
      "Plan and schedule Instagram posts with SeoBix to manage consistent publishing and content workflows.",
    keywords:
      "Instagram post scheduler, Instagram scheduler, social media scheduling, Instagram planning",
    breadcrumbName: "Instagram Post Scheduler",
    schemaType: "tool",
    softwareKeywords:
      "Instagram Post Scheduler, Instagram Scheduler, Social Media Scheduling, SMO Tool",
    featureList: [
      "Schedule Instagram Posts",
      "Plan Publishing Calendar",
      "Organize Social Content",
      "Improve Posting Consistency",
      "Support Instagram Strategy",
    ],
  },
  "/instagram-hashtag-generator": {
    path: "/instagram-hashtag-generator",
    title: "Instagram Hashtag Generator - Generate Relevant Hashtags",
    description:
      "Generate Instagram hashtags with SeoBix to improve post reach, topic targeting, and social media discovery.",
    keywords:
      "Instagram hashtag generator, Instagram hashtags, hashtag ideas, social media hashtags",
    breadcrumbName: "Instagram Hashtag Generator",
    schemaType: "tool",
    softwareKeywords:
      "Instagram Hashtag Generator, Instagram Hashtags, Hashtag Ideas, SMO Tool",
    featureList: [
      "Generate Instagram Hashtags",
      "Find Hashtag Ideas",
      "Improve Post Discovery",
      "Plan Hashtag Strategy",
      "Support Instagram Reach",
    ],
  },
  "/instagram-tag-analyzer": {
    path: "/instagram-tag-analyzer",
    title: "Instagram Tag Analyzer - Analyze Hashtag Performance",
    description:
      "Analyze Instagram tags and hashtag opportunities with SeoBix to improve reach and content targeting.",
    keywords:
      "Instagram tag analyzer, Instagram hashtag analyzer, hashtag performance, Instagram SEO",
    breadcrumbName: "Instagram Tag Analyzer",
    schemaType: "tool",
    softwareKeywords:
      "Instagram Tag Analyzer, Instagram Hashtag Analyzer, Hashtag Performance, SMO Tool",
    featureList: [
      "Analyze Instagram Tags",
      "Review Hashtag Opportunities",
      "Improve Content Targeting",
      "Support Post Reach",
      "Plan Instagram Hashtags",
    ],
  },
});

export function getSeoPage(path) {
  return seoPages[path] || null;
}
